import config from 'configDir/index';
import { get } from './http';

const serviceUrl = config.commonServiceUrl;
const baseUrl = '/noticeAnnouncement';
// 更新通知查看状态
const updateNoticeReadService = get(`${baseUrl}/updateRead`, serviceUrl);

export {
  // eslint-disable-next-line import/prefer-default-export
  updateNoticeReadService,
};
